import React from "react";
import styled from "styled-components";

import { COLORS } from "./SelectColor";

const Container = styled.div`
  display: flex;
`;

const Color = styled.div`
  width: 15px;
  height: 15px;
  margin: 5px;
  padding: ${props => props.active ? 2 : 0}px;
  border: ${props => props.active ? 1 : 0}px solid ${({ theme }) => theme.foreground};
  background-color: ${props => props.active ? "transparent" : props.color}

  :hover {
    background-color: transparent;
    border: 1px solid ${({ theme }) => theme.foreground};
    padding: 2px;
  }
`;

const InnerColor = styled.div`
  width: 100%;
  height: 100%;
`;

const ColorGrid = (props) => (
  <Container>
    {COLORS.map((color, index) =>
      <Color
        key={index}
        color={color}
        onClick={() => props.onChange(color)}
        active={props.value === color}
      >
        <InnerColor style={{ backgroundColor: color }} />
      </Color>
    )}
  </Container>
);

export default ColorGrid;


// WEBPACK FOOTER //
// ./src/components/Popup/ColorGrid.js